import useExternalModalOpen from './useExternalModalOpen';

/**
 * Cross-widget events ws-mycars-nav dispatches (document-scoped) reflecting
 * its own CONFIRMED modal visibility state (sourced from its isModalVisible
 * state transition, not from a dispatched open request). We deliberately
 * never infer "My Cars is open" from our own MYCARS_OPEN_MODAL_EVENT dispatch
 * (see MyCarsHeaderIcon/DrawerCTAButtons) — that click can be silently
 * dropped if ws-mycars-nav's own listener hasn't attached yet, which would
 * leave scroll locked with nothing left to ever unlock it.
 */
export const MYCARS_MODAL_OPENED_EVENT = 'ws-mycars-nav-modal-opened';
export const MYCARS_MODAL_CLOSED_EVENT = 'ws-mycars-nav-modal-closed';

/**
 * Tracks whether ws-mycars-nav's modal is currently open, per its own
 * confirmed state. Starts false; only ws-mycars-nav's events change it.
 *
 * @returns {boolean}
 */
const useMyCarsModalOpen = () =>
	useExternalModalOpen(MYCARS_MODAL_OPENED_EVENT, MYCARS_MODAL_CLOSED_EVENT);

export default useMyCarsModalOpen;
